/**
 * @generated SignedSource<<b67040096bfd42833a63096a87aa830e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CskCoralDrawer_contentResource$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CskCoralSectionContainer_contentResource">;
  readonly " $fragmentType": "CskCoralDrawer_contentResource";
};
export type CskCoralDrawer_contentResource$key = {
  readonly " $data"?: CskCoralDrawer_contentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"CskCoralDrawer_contentResource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CskCoralDrawer_contentResource",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CskCoralSectionContainer_contentResource"
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};

(node as any).hash = "c2639641ceebb5494c2598ca78eb1e29";

export default node;
